<template>
  <b-modal :id="modalId" header-class="warning">
    <template #modal-header>
      <div class="d-inline-flex justify-content-between w-100">
        <div class="w-100"> 
          <h5>{{ $t("engine.manageGridCell.cannotAddGrid.lblTitle", languageEngine) }}</h5>
        </div>
      </div>
      <div class="close px-2" type="button" style="font-size: 18px">
      </div>
      <div
        @click="closeModal()"
        type="button"
        aria-label="Close"
        id="close-modal-cannot-add-grid"
        class="close-modal"
      >
        <i class="fal fa-times"></i>
      </div>
    </template>
    <template>
      <div>
        {{ $t("engine.manageGridCell.cannotAddGrid.lblDetail", languageEngine) }}
      </div>
    </template>
    <template #modal-footer>
      <div class="float-right">
        <b-button variant="blue" @click="closeModal">{{ $t("engine.manageGridCell.cannotAddGrid.lblBtnConfirm", languageEngine) }}</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      modal: "design/modal",
      languageEngine: "design/userPreference/languageEngine",
    }),
  },
  data() {
    return {
      modalId: "modal-cannot-add-grid"
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(this.modalId);
      this.$store.dispatch("design/setModal", { name: "" });
    }
  },
  watch: {
    modal: {
      handler() {
        if (this.modal == this.modalId) {
          this.$bvModal.show(this.modalId);
        }
      },
    },
  }
}
</script>